export const LicenseTypes = {
  PlusLicense: "PlusLicense", //Only apl, but as part of bundle
  APLOnly: "APLOnly", //Only apl, not as part of bundle
  StudentLicense: "StudentLicense", //Only studentlicense
  StudentLicencePlus: "StudentLicencePlus", //Bundle with studentlicense and plus
};
